import React from "react";
import { Link } from "react-router-dom";
import { money } from "../lib/api";

const AUD_LABEL = { Adult: "Adult", Youth: "Youth", Women: "Women's" };

export function ProductCard({ product, colorway }) {
  const cw = colorway && product.colorways?.find((c) => c.key === colorway);
  const img = cw?.images?.[0]?.url || product.images?.front;
  return (
    <Link
      to={`/product/${product.id}${cw ? `?cw=${cw.key}` : ""}`}
      data-testid={`product-card-${product.id}`}
      className="group relative block bg-[#121216] border border-white/10 rounded-lg overflow-hidden hover:border-yellow-400/50 hover:-translate-y-1 transition-[transform,border-color] duration-200"
    >
      <div className="relative aspect-[3/2] overflow-hidden bg-[#0A0A0C]">
        {img ? (
          <img
            src={img}
            alt={cw ? `${product.name} in ${cw.label}` : product.name}
            className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-zinc-600">No image</div>
        )}
        <div className="absolute top-2 left-2 right-2 flex items-start justify-between gap-2 pointer-events-none">
          {product.preorder_round_id && (
            <span className="bg-yellow-400 text-black font-mono font-bold text-[9px] px-2 py-1 uppercase tracking-widest rounded-sm">
              Winter '26
            </span>
          )}
          {AUD_LABEL[product.audience] && (
            <span className="ml-auto text-[9px] font-mono uppercase tracking-wider bg-black/70 text-zinc-200 px-2 py-1 rounded-sm border border-white/10">
              {AUD_LABEL[product.audience]}
            </span>
          )}
        </div>
      </div>
      <div className="p-4">
        <p className="text-[11px] font-mono uppercase tracking-widest text-zinc-500">{product.category}</p>
        <h4 data-testid={`product-card-name-${product.id}`} className="font-heading text-lg font-bold text-white leading-tight mt-1 line-clamp-2 group-hover:text-yellow-400 transition-colors">
          {product.name}
        </h4>
        <div className="mt-2 flex items-baseline gap-2 flex-wrap">
          <span className="font-mono text-yellow-400 font-bold">{money(product.retail_price)}</span>
          {product.colorways?.length > 1 && (
            <span className="text-[10px] text-zinc-500 font-mono">{product.colorways.length} colorways</span>
          )}
        </div>
      </div>
    </Link>
  );
}
